import React, { createContext, useContext, useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import useApi from '../projects/shared/hooks/useApi';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userRoles, setUserRoles] = useState(null);
    const [allowedPages, setAllowedPages] = useState(null);
    const [allowedProjects, setAllowedProjects] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { apiGet } = useApi();
    const fetchUserPermissions = async () => {
        try {

            const getDataRoute = `/get-user-info`;
            const data = await apiGet("UX_HTTP_API", getDataRoute);
            if (data.projects) {
                const projectNames = data.projects.map(project => project.name);
                const roles = data.projects.map(project => 
                    Object.keys(project.roles).map(role => role.toLowerCase())
                ).flat();
                const pages = getAllPages(data.projects);

                setAllowedProjects(projectNames);
                setUserRoles(roles);
                setAllowedPages(pages);

                // Still store in localStorage as backup
                localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
                localStorage.setItem('all_roles', JSON.stringify(roles));
                localStorage.setItem('allowedPages', JSON.stringify(pages));
            }
        } catch (error) {
            console.error('Auth Context fetchUserPermissions Error fetching user permissions:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getAllPages = (projects) => {
        let allPages = [];
        projects.forEach((project) => {
            Object.values(project.roles).forEach((role) => {
                if (role.pages) {
                    allPages.push(...role.pages);
                }
            });
        });
        return [...new Set(allPages)];
    };

    useEffect(() => {
        const initAuth = async () => {
            try {
                const session = await Auth.currentSession();
                if (session) {
                    await fetchUserPermissions();
                }
            } catch (error) {
                setIsLoading(false);
            }
        };

        initAuth();
    }, []);

    const refreshPermissions = () => {
        fetchUserPermissions();
    };

    return (
        <AuthContext.Provider value={{
            userRoles,
            allowedPages,
            allowedProjects,
            isLoading,
            refreshPermissions
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};